'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _uiTranslations = require('@wh/ui-translations');

var _modal = require('./modal');

var _modal2 = _interopRequireDefault(_modal);

var _selectors = require('./selectors');

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    activeModalName: _selectors.getActiveModalName
});

var mapDispatchToProps = {
    openModal: _actions.openModal,
    closeModal: _actions.closeModal
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _uiTranslations.withTranslator)(_modal2.default));
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/modal-component/dist/main/Container.js
// module id = 505
// module chunks = 0